import React from "react";
import { LoaderCircle } from "lucide-react";

export const RouteMapLoading = ({ phase }) => {
  if (phase !== "requesting" && phase !== "generating") return null;
  return <div className="demo-map-loading" data-testid="demo-map-loading">
    <LoaderCircle size={19} aria-hidden="true" />
    <div>
      <strong data-testid="demo-map-loading-title">{phase === "requesting" ? "Helios is connecting your map" : "Helios is revealing your routes"}</strong>
      <span data-testid="demo-map-loading-detail">{phase === "requesting" ? "Decision steps are forming. Routes are not ready yet." : "Five steps. Three paths. Ready for your review shortly."}</span>
    </div>
  </div>;
};